import { fetch } from "@/helpers";

export const airportService = {
  getAirportlists,
  getAirport,
  getNotice,
  uploadNotice,
  deleteNotice
};

export function getAirportlists(params) {
  return fetch
    .get("/3/airports/getairports/", { params })
    .then(res => JSON.parse(res.data.replace(/\bNaN\b/g, "null")));
}

export function getAirport(airportId) {
  return fetch.get(`/1/airports/getairport/${airportId}`);
}

export function getNotice(code) {
  return fetch.get(`/1/airports/notice/${code}`);
}

export function uploadNotice(notice) {
  return fetch.post("/1/airports/notice/", notice);
}

export function deleteNotice() {
  return fetch.delete("/1/airports/notice/");
}
